import { t } from '@lingui/macro';
import { WeldSetupAdminTab, WeldSetupAdminTabType } from './types';

export const weldSetupAdminTabList: WeldSetupAdminTab[] = [
  { label: t`Piping`, value: WeldSetupAdminTabType.PIPING },
  { label: t`Structural`, value: WeldSetupAdminTabType.STRUCTURAL },
];
